var exports = {
  "kL": "Tabs.module__container___bXhrRk",
  "Mf": "Tabs.module__tab___bXhrRk",
  "wH": "Tabs.module__selected___bXhrRk",
};

module.exports = exports;
